import http from '../fetch';
const { get: httpGet, post: httpPost } = http;

// 登陆
export const loginAccount = data => httpPost('/login', data);

//获取当前登陆用户
export const getCurrentUserName = () => httpGet('/currentUserName');

// 检查是否是管理员
export const checkIsAdmin = () => httpGet('/isAdmin');



// WEBPACK FOOTER //
// ./src/api/login/index.js